module.exports = __webpack_public_path__ + "static/media/loginbg.46b61715.png";